"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogSurfaceContext: function() {
        return DialogSurfaceContext;
    },
    DialogSurfaceProvider: function() {
        return DialogSurfaceProvider;
    },
    useDialogSurfaceContext_unstable: function() {
        return useDialogSurfaceContext_unstable;
    }
});
const _react = require("react");
const defaultContextValue = false;
const DialogSurfaceContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
const DialogSurfaceProvider = DialogSurfaceContext.Provider;
const useDialogSurfaceContext_unstable = ()=>{
    var _useContext;
    return (_useContext = (0, _react.useContext)(DialogSurfaceContext)) !== null && _useContext !== void 0 ? _useContext : defaultContextValue;
};
